// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    dashboard: path(ROOTS_DASHBOARD, '/smart-collect'),
    master_data: path(ROOTS_DASHBOARD, '/master-data'),
    client: path(ROOTS_DASHBOARD, '/master-data/client'),
    vendor: path(ROOTS_DASHBOARD, '/master-data/vendor'),
    project: path(ROOTS_DASHBOARD, '/master-data/project'),
    header: path(ROOTS_DASHBOARD, '/master-data/header'),
    columnmap: path(ROOTS_DASHBOARD, '/master-data/column-map'),
    exclusion_rule: path(ROOTS_DASHBOARD, '/master-data/filtering-rule'),
    campaign_rule: path(ROOTS_DASHBOARD, '/master-data/campaign-rule'),
    project_config: path(ROOTS_DASHBOARD, '/master-data/project-config'),
    file_manager: path(ROOTS_DASHBOARD, '/file-manager'),
    master_file: path(ROOTS_DASHBOARD, '/file-manager/file_management'),
    file_category: path(ROOTS_DASHBOARD, '/file-manager/file_type'),
    increment_file: path(ROOTS_DASHBOARD, '/file-manager/increment_file'),
    campaign_file: path(ROOTS_DASHBOARD, '/file-manager/campaign_file'),
    collection_data: path(ROOTS_DASHBOARD, '/collection-data'),
    collection: path(ROOTS_DASHBOARD, '/collection-data/collection'),
    scoring: path(ROOTS_DASHBOARD, '/collection-data/scoring-model'),
    segmentation: path(ROOTS_DASHBOARD, '/collection-data/segmentation'),
    user_management: path(ROOTS_DASHBOARD, '/user-management'),
    user_role: path(ROOTS_DASHBOARD, '/user-management/user_role'),
    users: path(ROOTS_DASHBOARD, '/user-management/users'),
    customer_search: path(ROOTS_DASHBOARD, '/customer-search'),
    reports: path(ROOTS_DASHBOARD, '/reports'),
    omni_channel: path(ROOTS_DASHBOARD, '/omni_channel'),
    qa: path(ROOTS_DASHBOARD, '/qa'),
    createClientForm: path(ROOTS_DASHBOARD, '/create-client/createclient-form'),
    score: path(ROOTS_DASHBOARD, '/score'),
    Staff: path(ROOTS_DASHBOARD, '/staff'),
    Scorecards: path(ROOTS_DASHBOARD, '/scorecards'),
    Calibration: path(ROOTS_DASHBOARD, '/calibration')
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all')
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    settings: path(ROOTS_DASHBOARD, '/user/settings')
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  }
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
